import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Login from './components/Login';
import OTPVerification from './components/OTPVerification';
import LoanTypeSelection from './components/LoanTypeSelection';
import TreatmentDetails from './components/TreatmentDetails';
import PatientInfo from './components/PatientInfo';
import PersonalDetails from './components/PersonalDetails';
import AddressDetails from './components/AddressDetails';
import EmploymentDetails from './components/EmploymentDetails';
import PersonalLoanMessage from './components/PersonalLoanMessage';
import LenderSuccessPage from './components/LenderSuccessPage';
import HelpButton from './components/HelpButton';
import LoanSanctioned from './components/LoanSanctioned';
import ScrollToTop from './components/ScrollToTop';
import ProtectedRoute from './components/ProtectedRoute';
import ErrorPage from './components/ErrorPage';

function App() {
  return (
    <Router>
      <ScrollToTop>
        <div className="app">
          <Routes>
            {/* Public routes - no authentication required */}
            <Route path="/" element={<Login />} />
            <Route path="/:anchor/" element={<Login />} />
            <Route path="/:anchor/otp" element={<OTPVerification />} />
            
            {/* Protected routes - require authentication */}
            <Route 
              path="/:anchor/loan-type" 
              element={
                <ProtectedRoute>
                  <LoanTypeSelection />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/:anchor/treatment-details" 
              element={
                <ProtectedRoute>
                  <TreatmentDetails />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/:anchor/patient-info" 
              element={
                <ProtectedRoute>
                  <PatientInfo />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/:anchor/personal-details" 
              element={
                <ProtectedRoute>
                  <PersonalDetails />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/:anchor/address-details" 
              element={
                <ProtectedRoute>
                  <AddressDetails />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/:anchor/employment-details" 
              element={
                <ProtectedRoute>
                  <EmploymentDetails />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/:anchor/personal-loan-message" 
              element={
                <ProtectedRoute>
                  <PersonalLoanMessage />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/:anchor/lender-success" 
              element={
                <ProtectedRoute>
                  <LenderSuccessPage />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/:anchor/loan-sanctioned" 
              element={
                <ProtectedRoute>
                  <LoanSanctioned />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/:anchor/error" 
              element={
                <ProtectedRoute>
                  <ErrorPage />
                </ProtectedRoute>
              } 
            />
          </Routes>
          
          {/* Global Help Button - appears on all pages */}
          <HelpButton />
        </div>
      </ScrollToTop>
    </Router>
  );
}

export default App;
